import { useEffect, useState } from 'react';
import { useDiscover } from 'src/hook/components/useDiscover';
import { useGeneralSettings } from 'src/hook/data/useGeneralSettings';
import useUser from 'src/hook/data/useUser';
import usePopUp from 'src/hook/modal/usePopUp';
import styles from './RangePopUp.module.scss';
interface RangePopUpProps {
    isEasy: boolean;
}



const RangePopUp = ({ isEasy }: RangePopUpProps) => {
    const { hide } = usePopUp();
    const { userInfo } = useUser();
    const { incrementRangePopUpCount, generalSettings, updateGeneralSettings } = useGeneralSettings();
    const [selected, setSelected] = useState(500);
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const [showCheckbox, setShowCheckbox] = useState(false);
    const currentRange = userInfo?.SelectedRange || 1;
    const { setUpdatedRange } = useDiscover();

    const OPTIONS = [
        { label: `Jump ${!isEasy ? 'back' : ''} 500 words`, value: 500, step: 5 },
        { label: `Jump ${!isEasy ? 'back' : ''} 1000 words`, value: 1000, step: 10 },
        { label: `Jump ${!isEasy ? 'back' : ''} 2000 words`, value: 2000, step: 20 },
    ];

    const availableOptions = [OPTIONS[0]];

    if (isEasy) {
        if (currentRange + 10 <= 243) availableOptions.push(OPTIONS[1]);
        if (currentRange + 20 <= 243) availableOptions.push(OPTIONS[2]);
    } else {
        if (currentRange - 10 >= 1) availableOptions.push(OPTIONS[1]);
        if (currentRange - 20 >= 1) availableOptions.push(OPTIONS[2]);
    }


    const handleApply = () => {
        let step = 5;
        if (selected === 1000) step = 10;
        if (selected === 2000) step = 20;
        let newRange = isEasy ? currentRange + step : currentRange - step;
        if (newRange < 1) newRange = 1;
        if (newRange > 243) newRange = 243;
        setUpdatedRange(newRange);
        if (showCheckbox && dontShowAgain) {
            console.log('dontShowAgain');
            updateGeneralSettings({ ShowRangePopUp: false });
        }
        hide();
    };


    useEffect(() => {
        incrementRangePopUpCount();
        if ((generalSettings.RangePopUpCount || 0) + 1 >= 3) {
            setShowCheckbox(true);
        }
    }, []);


    if (!userInfo) return null;

    return (
        <div className={styles.RangePopUp}>
            <h1 className={styles.title}>
                Too {isEasy ? 'easy' : 'difficult'}?
            </h1>
            <div className={styles.options}>
                {availableOptions.map(opt => (
                    <div key={opt.value} className={styles.optionRow}>
                        <label className={styles.optionLabel}>
                            <input
                                type="radio"
                                name="range-option"
                                value={opt.value}
                                checked={selected === opt.value}
                                onChange={() => setSelected(opt.value)}
                                className={styles.radio}
                            />
                            {opt.label}
                        </label>
                    </div>
                ))}
            </div>
            {showCheckbox && (
                <div className={styles.checkboxRow}>
                    <label className={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            checked={dontShowAgain}
                            onChange={e => setDontShowAgain(e.target.checked)}
                            className={styles.checkbox}
                        />
                        Don't ask me again.
                    </label>
                </div>
            )}
            <div className={styles.buttonRow}>
                <button onClick={hide} className='secondaryButton'>Cancel</button>
                <button onClick={handleApply} >Apply</button>
            </div>
        </div>
    );
};

export default RangePopUp;